// extracted by mini-css-extract-plugin
export default {"container":"J9hpmTFD","overlay":"eLRylnZZ","overlayTop":"T6CXmKSS","overlayContentTop":"_0Aj3xTG","overlayContent":"OZSXu8F8","slider":"lLVAMDEd"};